module.exports = __webpack_public_path__ + "img/scrub6.deca9e65.jpg";